<template lang="html">
    <div class="centerx" style="min-width: 800px;">
        <vs-table :data="displayedTasks" class="mt-4" stripe>
          <template slot="thead">
            <vs-th sort-key="contract_id">N° Contrat</vs-th>
            <vs-th sort-key="mission_id">Tâche</vs-th>
            <vs-th sort-key="commentary">Commentaire</vs-th>
            <vs-th sort-key="link">Lien</vs-th>
            <vs-th sort-key="creation_date">Date de création</vs-th>
            <vs-th sort-key="finished_date">Date d'achèvement</vs-th>
            <vs-th sort-key="archivate">Statut</vs-th>
            <vs-th></vs-th>
            <vs-th v-if="$acl.check('sadmin')"></vs-th>
          </template>

          <template slot-scope="{data}">
	<vs-tr :key="index" v-for="(task, index) in data">
		<vs-td>{{ task.contract_id }}</vs-td>
		<vs-td>{{
			task.mission_id ? getMissionProduct(task.mission_id) : task.commentary
		}}</vs-td>
		<vs-td>{{ task.commentary }}</vs-td>
		<vs-td>{{ task.link }}</vs-td>
		<vs-td>
			{{ getDateToFrenchFormat(task.creation_date.substring(0, 10)) }}
		</vs-td>
		<vs-td>
			{{
				task.finished_date
					? getDateToFrenchFormat(task.finished_date.substring(0, 10))
					: " "
			}}
		</vs-td>
		<vs-td>
			<SliderWith3btn
				v-model="task.archivate"
				:id1="task.id + 'off'"
				:id2="task.id + 'null'"
				:id3="task.id + 'on'"
				styleSld="font-size: 10px; background-color: rgba(224, 224, 224, 0.78);width: 165px;"
				styleOp1="color: black; background-color: #FF0000; width:55px; padding: 5px 10px;"
				styleOp2="color: black; background-color: #FFA800; width:55px; padding: 5px 10px;"
				styleOp3="color: black; background-color: #28C76F; width:55px; padding: 5px 10px;"
				styleDefault="color: black;"
				option1="Annulé"
				option2="À faire"
				option3="Fait"
				@btn-selected="updateTask(task, $event)"
			/>
		</vs-td>
		<vs-td v-if="$acl.check('accountmanager') && task.document_count <= 0">
			<vx-tooltip text="Ajouter un lien" position="top">
				<vs-button
					size="large"
					color="primary"
					type="flat"
					icon-pack="feather"
					icon="icon-plus-circle"
					@click="displayLinkPopup(task)"
				></vs-button>
			</vx-tooltip>
		</vs-td>
		<vs-td v-if="task.document_count > 0">
			<vx-tooltip text="Voir les documents partagés" position="top">
				<vs-button
					size="large"
					color="rgba(243, 222, 239, 0.4)"
					text-color="purple"
					type="flat"
					icon-pack="feather"
					icon="icon-file-text"
					@click="displayLinkPopup(task)"
				></vs-button>
			</vx-tooltip>
		</vs-td>
		<vs-td v-if="$acl.check('sadmin') && !task.mission_id">
			<vx-tooltip text="Effacer" position="top">
				<vs-button
					size="large"
					color="danger"
					type="flat"
					icon-pack="feather"
					icon="icon-trash-2"
					@click="deleteTask(task)"
				></vs-button>
			</vx-tooltip>
		</vs-td>
		<vs-td v-if="$acl.check('sadmin') && task.mission_id"></vs-td>
	</vs-tr>
</template>
        </vs-table>
		<vs-popup
			:active.sync="showConfirmationPopup"
			title="Êtes-vous sûr de vouloir valider la supression du document ?"
		>
			<div class="vx-row" style="z-index: 100 !important;">
				<div class="vx-col sm:w-1/2">
					<vs-button color="primary" class="mt-2 w-full" @click="accept()">Oui</vs-button>
				</div>
				<div class="vx-col sm:w-1/2">
					<vs-button color="primary" class="mt-2 w-full" @click="decline()">Non</vs-button>
				</div>
			</div>
		</vs-popup>
		<vs-popup :title="getSocietyName(society_id) + ', Contrat N°' + contract_id + ' : ' + getMissionProduct(mission_id)" :active.sync="showLinkPopup">
			<ShareLinkPopup
				v-model="showLinkPopup"
				:apiUrl="apiUrl"
				:society_id="society_id"
				:mission_id="mission_id"
				:task_id="task_id"
				:contract_id="contract_id"
				@open-confirmation="confirmation(arguments)"
				ref="shareLink"
			/>
		</vs-popup>
      </div>
  </div>
</template>

<script>
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin";
import "@/assets/css/toggle-switch.css";

import store from "@/store/store";
import ShareLinkPopup from "@/components/popups/ShareLinkPopup";
import SliderWith3btn from "@/components/widgets/SliderWith3btn";

export default {
	name: "ValidateTaskTable",
	props: {
		tasks: Array,
		router: Object,
		apiUrl: String,
		contractId: Number
	},
	mixins: [dbFieldConvertor, utilsMixin],
	components: {
		ShareLinkPopup,
		SliderWith3btn
	},
	created(){
		this.getProductDescriptionByMissionIdSet(this.$props.tasks);
		let allTasks = JSON.parse(JSON.stringify(this.$props.tasks));

		this.displayedTasks = JSON.parse(JSON.stringify(allTasks));
	},
	computed: {
		societies: () => {
			return store.state.societies;
		}
	},
	watch: {
		tasks: function(data){
			this.getProductDescriptionByMissionIdSet(data);
			let allTasks = JSON.parse(JSON.stringify(data));
	
			this.displayedTasks = JSON.parse(JSON.stringify(allTasks));
		},
		society: function(data) {
			this.getAllRelatedUser(data.id);
			this.getCommercialSociety(data.commercial_id);
		},
		/*
		 * contractNumberFilter: function() {
		 * if(this.contractNumberFilter == "") {
		 * this.contractNumberFilterOn = false
		 * }else{
		 * this.contractNumberFilterOn = true
		 * }
		 * //console.log("contractNumberFilter")
		 * this.displayedTasks = this.filterTasks(this.allTasks) //A CHANGER
		 * },
		 */
		taskFilter: function() {
			if(this.taskFilter == "") {
				this.taskFilterOn = false;
			}
			else{
				this.taskFilterOn = true;
			}
			this.displayedTasks = this.filterTasks(this.allTasks); //A CHANGER
		},
	},

	data() {
		return {
			missionsProduct: [],
			allTasks: [],
			displayedTasks: [],
			contractNumberFilter: null,
			taskFilter: null,
			//contractNumberFilterOn: false,
			taskFilterOn: false,
			showLinkPopup: false,
			society_id: null,
			task_id: null,
			contract_id: null,
			mission_id: null,
			showConfirmationPopup: false,
			docId: ""
		};
	},

	methods: {
		accept(){
			this.deleteDoc(this.docId);
			this.showConfirmationPopup = false;
		},
		confirmation(param){
			this.showConfirmationPopup = param[0];
			this.docId = param[1];
		},

		decline(){
			this.docId = "";
			this.showConfirmationPopup = false;
		},

		deleteDoc(docId){
			this.$http.delete(this.apiUrl + "shared_document/delete/document/" + docId)
				.then(() => {
					this.$refs.shareLink.refreshList(this.task_id);
				}
				);
		},
		getSocietyName(society_id){
			let society_name = "";
			let foundSociety = this.societies.findIndex(row => row.id == society_id);
			if(foundSociety >= 0){
				society_name = this.societies[foundSociety].name;
			}
			return society_name;
		},
		displayLinkPopup(task) {
			this.showLinkPopup == true ? this.showLinkPopup = false : this.showLinkPopup = true;

			this.society_id = task.contract_society_id;
			this.task_id = task.id;
			this.contract_id = task.contract_id;
			this.mission_id = task.mission_id;
			this.showLinkPopup = true;
		},
		/**
		 * Get all Mission IDs for all tasks
		 * @param {Object} tasks - Task List Object
		 * @return - Array of contract IDs
		 */
		getAllTasksMissionIds(tasks){
			let mission_ids = [];
			for(let task of tasks){
				if(mission_ids.length > 0){
					if(task.mission_id){
						if(!mission_ids.includes(task.mission_id)){
							mission_ids.push(task.mission_id);
						}
					}
				}
				else{
					if(task.mission_id){
						mission_ids.push(task.mission_id);
					}
				}
			}
			return mission_ids;
		},

		/**
		 * Fetch Missions descriptions by mission ID for a set of IDs
		 * @param {Object} tasks - Task List Object
		 */
		getProductDescriptionByMissionIdSet(tasks){
			//console.log("getProductDescriptionByMissionIdSet tasks", tasks);
			if(tasks.length <= 0) return;
			let string_mission_ids = `[${tasks[0].mission_id}]`;
			//console.log("string_contract_ids", string_mission_ids);
			this.$http
				.get(this.apiUrl + "mission/allpdesc/", {
					params: {
						missionids: string_mission_ids
					}
				})
				.then(res => {
					//console.log(res.data);
					this.missionsProduct = res.data;
				})
				.catch(err => {
					//console.log(err);
				});
		},

		/**
		 * Get Contract Type from list by Contract ID
		 * @param {Number} contractId - ID of the contract to get category for
		 * @return {Number} - Contract's category ID
		 */
		getMissionProduct(missionId){
			for(let mission of this.missionsProduct){
				if(mission.id == missionId){
					return mission.perform;
				}
			}
			return " ";
		},
		/**
		 * Update changed task
		 * @param {Object}
		 */
		updateTask(task, task_state){
			//console.log("task", task);

			let today = new Date(Date.now());
			today = today.toISOString();
			/*
			 * today = today.substring(0,10)
			 * today = today + " 02:00:00"
			 */

			let re = new RegExp("([T|Z])", "g");
			let creation_date = task.creation_date.replace(re, " ");
			today = today.replace(re, " ");
			let finished_date = task.archivate ? today : null;

			this.$http.post(this.apiUrl + "task/edit/" + task.id, {
				commentary: task.commentary,
				link: task.link,
				status: task.status,
				creation_date: creation_date,
				finished_date: finished_date,
				recurrence: task.recurrence,
				frequency: task.frequency,
				archivate: task_state,
				contract_id: task.contract_id,
				contract_society_id: task.contract_society_id,
				mission_id: task.mission_id,
			}).then(res => {

				//console.log("resTask", res);
				if(!task.recurrence || task.recurrence == 0){
					let mission_status = 1;
					if(task_state == 1){
						mission_status = 7;
					}
					else if(task_state == 0 || task_state == 2){
						mission_status = 1;
					}
					this.$http.post(this.apiUrl + "mission/editarch", {
						contract_id: task.contract_id,
						status: mission_status,
						id: task.mission_id,
					}).then(res => {
						//console.log("resMission", res);
						this.$vs.notify({title: "Succès", text: "Tâche modifiée avec succès."});
						store.dispatch("getAllTasks");
						this.$emit("refresh-task");
					}).catch(err => {
						//console.log(err);
						this.$vs.notify({title: "Echec", text: "La tâche n'a pas été modifiée."});
					});
				}
				else{
					this.$vs.notify({title: "Succès", text: "Tâche modifiée avec succès."});
					this.$emit("update-task", [task, task_state]);
				}
			}).catch(err => {
				//console.log(err);
				this.$vs.notify({title: "Echec", text: "La tâche n'a pas été ajoutée."});
			});
		},

		/**
		 * Delete the contact passed in argument
		 * @param {Number} contactId - Contact ID to delete
		 */
		deleteTask(task){
			this.$http.delete(this.apiUrl + "task/delete/" + task.id.toString())
				.then(() => {
					// Send a success notification to the user
					this.$vs.notify({
						title: "Succès",
						text: "Tâche effacée avec succès."
					});
					// Refresh List
					store.dispatch("getAllTasks");
					for(let i = 0; i < this.displayedTasks.length; i++){
						if(this.displayedTasks[i].id == task.id) this.displayedTasks.splice(i, 1);
					}
					this.$forceUpdate();
				})
				.catch(err => {
					//console.log(err);
					this.$vs.notify({
						title: "Erreur",
						text: "La tâche n'a pas été effacée."
					});
				});
		},

		/**
		 * Return true if a filter has been set
		 * @return {Boolean} - Is filter set ?
		 */
		isFilterSet(){
			if(this.taskFilterOn) return true;
			return false;
		},

		/**
		 * Return list of filtered tasks
		 * @param {String} taskFilter - Id of the mission product associated to the task
		 * @param {String} contractNumberFilter - Contract Number in String format can be partial
		 * @return {List} - Societies' list filtered
		 */
		filterTasks(tasks){
			let tasksList = [];

			let searchKeyList = {};
			this.taskFilterOn ? searchKeyList["taskFilter"] = this.taskFilter : false;
			//this.contractNumberFilterOn ? searchKeyList["contractNumberFilter"] = this.contractNumberFilter.toString()  : false;

			for(let taskToFilter of tasks){
				let taskSearchKeyList = {};
				//this.contractNumberFilterOn ? taskSearchKeyList["contractNumberFilter"] = taskToFilter.contract_id.toString() : false;
				this.taskFilterOn ? taskSearchKeyList["taskFilter"] = taskToFilter.mission_id : false; // ADAPTER POUR RECUPERER LA LISTE D'AM LIEE AU CONTRAT DE LA TACHE

				let check = true;

				for(let key in searchKeyList) {
					/*
					 * //console.log("TYPE")
					 * //console.log(typeof purchaseSearchKeyList[key])
					 */
					if(typeof searchKeyList[key] == "string"){
						if(typeof taskSearchKeyList[key] == "string"){
							if(!taskSearchKeyList[key].includes(searchKeyList[key])){
								check = false;
								break;
							}
						}
						else if(typeof taskSearchKeyList[key] == "object"){
							////console.log("Array")
							let checkLoop = false;
							for(let value of taskSearchKeyList[key]){
								let service_name = this.getServiceIdToName(value).toLowerCase();
								/*
								 * //console.log(service_name)
								 * //console.log(searchKeyList[key])
								 */
								if(service_name.includes(searchKeyList[key])){
									////console.log("checkLoop = true;")
									checkLoop = true;
								}
							}
							if(!checkLoop){
								check = checkLoop;
								break;
							}
						}
					}
					else{
						if(Array.isArray(taskSearchKeyList[key])){
							//console.log("isArray");
							//console.log(taskSearchKeyList[key]);
							//console.log(searchKeyList[key]);
							if(!taskSearchKeyList[key].includes(searchKeyList[key])){
								check = false;
								break;
							}
						}
						else{
							if(taskSearchKeyList[key] != searchKeyList[key]){
								check = false;
								break;
							}
						}
					}
				}

				if(check) tasksList.push(taskToFilter);
			}
			/*
			 * return result
			 * //console.log("filterProviders END")
			 */
			//console.log(tasksList);
			return tasksList;
		},
	}
};
</script>

<style scoped>
.center {
  justify-content: center;
}

.right-elem {
  justify-content: flex-end;
}

.bg-color {
  background: #35e9fd !important;
}

.t-border {
  border-top: 1px solid grey;
}

.l-border {
  border-left: 1px solid grey;
}

.title {
  font-weight: 600;
  font-size: 2em;
}

.f-color {
  color: black;
}

.center-align {
  display: flex;
  align-items: center;
}

.no-width-limit{
  width: unset;
}
</style>
